<div class="address-field-append">
  <h4 class="with"><span>with</span></h4>
  <div class="replace-container">
    <label>
      <input type="text" placeholder="Empty string" [formControl]="fieldControl">
    </label>
  </div>
</div>
